import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Trip } from '@uzurv/clara';
import { UzurvTableColumnDefinition } from '@uzurv/http';
import { CurrencyPipe } from '@angular/common';
import { ReservationStatusNameConstants, RideRequestTypeConstants, isNullOrUndefined, DateFormatConstants } from '@uzurv/core';
import moment from 'moment-timezone';
import { GenericListModule } from '../generic-list';

@Component({
  selector: 'app-rider-ride-history',
  templateUrl: './rider-ride-history.component.html',
  styleUrls: ['./rider-ride-history.component.scss'],
  imports: [GenericListModule],
  standalone: true
})
export class RiderRideHistoryComponent {
  @Input() trips: Array<Trip>;
  @Input() pageIndex: number;
  @Input() pageSize: number;

  @Output() paginate: EventEmitter<PageEvent> = new EventEmitter();
  @Output() goToTrip: EventEmitter<Trip> = new EventEmitter();

  shouldShowLoader = false;

  columns: Array<UzurvTableColumnDefinition> = [
    {
      columnDef: 'pickupDate',
      title: 'Pick-up',
      cell: (trip: Trip) => {
        return trip.formattedDisplayDate;
      }
    },
    {
      columnDef: 'driverName',
      title: 'Driver',
      cell: (trip: Trip) => (!isNullOrUndefined(trip.driverName) ? trip.driverName : 'N/A')
    },

    {
      columnDef: 'organization',
      title: 'Organization',
      cell: (trip: Trip) => trip.organizationCode
    },

    {
      columnDef: 'status',
      title: 'Status',
      cell: (trip: Trip) => trip.status
    }
  ];

  constructor() {}

  handleTripSelected(trip: Trip): void {
    this.goToTrip.emit(trip);
  }

  handlePaginationChange(pageEvent: PageEvent) {
    this.paginate.emit(pageEvent);
  }
}
